import {Component,Input,OnDestroy,ViewChild} from '@angular/core';
import {Od} from "../../../../domain/od/od";
import {OdEngagementsResumeComponent} from "./resume/od-engagements-resume.component";
import {OdEngagementsIndemnitesComponent} from "./indemnites/od-engagements-indemnites.component";
import {OdEngagementsFraisComponent} from "./frais/od-engagements-frais.component";
import {OdEngagementsFacturesComponent} from "./factures/od-engagements-factures.component";
import {Contexte} from "../../../../domain/od/engagements/indemnites/contexte";
import {ODService} from "../../od.service";
import {Subscription} from "rxjs";

/**
 * Composant de l'onglet "Engagements" de l'OD
 *
 * @author Laurent Convert
 * @date 26/10/2021
 */
@Component({
	selector: 'od-engagements',
	templateUrl: './od-engagements.component.html'
})
export class OdEngagementsComponent implements OnDestroy {
	/* Déclaration pour usage depuis le template */
	Contexte = Contexte;

	/** Ordre de mission */
	@Input() od: Od = null;

	/** Composant du résumé */
	@ViewChild("resume")
	resume: OdEngagementsResumeComponent;

	/** Composant des frais */
	@ViewChild("frais")
	frais: OdEngagementsFraisComponent;

	/** Composant des factures */
	@ViewChild("factures")
	factures: OdEngagementsFacturesComponent;

	/** Composant des indemnités */
	@ViewChild("indemnites")
	indemnites: OdEngagementsIndemnitesComponent;

	/** Souscription à l'enregistrement des temps */
	subSaisieTemps: Subscription;

	/**
	 * Constructeur
	 *
	 * @param odService Service de gestion des composants de l'OD
	 */
	constructor(odService: ODService) {
		//Abonnement à l'enregistrement de la saisie des temps
		this.subSaisieTemps = odService.saisieTempsDone$.subscribe(() => {
			//Rechargement de l'affichage des IJ
			this.refresh();
		});
	}

	/**
	 * Handler appellé lors de la destruction du composant
	 */
	ngOnDestroy() {
		this.subSaisieTemps?.unsubscribe();
	}

	/**
	 * Rafraichissement de tous les composants enfants
	 */
	refresh(): void {
		this.resume.refresh();
		this.frais.refresh();
		this.factures.refresh();
		this.indemnites.refresh();
	}

}